/**
 * WebRTC 连接状态管理 Store。
 */
import { create } from "zustand";

export type WebRTCState = {
	peerIdentity: RTCIdentityAssertion | null;
	signalingState: RTCSignalingState | null;
	iceConnectionState: RTCIceConnectionState | null;
	connectionState: RTCPeerConnectionState | null;
	stream: MediaStream | null;
	error: string | null;
	isIceRestarting: boolean;
};

type WebRTCStoreState = WebRTCState & {
	setPeerIdentity: (identity: RTCIdentityAssertion | null) => void;
	setSignalingState: (state: RTCSignalingState) => void;
	setIceConnectionState: (state: RTCIceConnectionState) => void;
	setConnectionState: (state: RTCPeerConnectionState) => void;
	setStream: (stream: MediaStream | null) => void;
	setError: (error: string | null) => void;
	setIceRestarting: (isRestarting: boolean) => void;
	reset: () => void;
};

const initialState: WebRTCState = {
	peerIdentity: null,
	signalingState: null,
	iceConnectionState: null,
	connectionState: null,
	stream: null,
	error: null,
	isIceRestarting: false,
};

export const useWebRTCStore = create<WebRTCStoreState>((set) => ({
	...initialState,

	// 更新 peer identity
	setPeerIdentity: (identity) => {
		console.log("设置 peer identity:", identity);
		set({ peerIdentity: identity });
	},

	// 更新信令状态
	setSignalingState: (state) => {
		console.log("设置信令状态:", state);
		set({ signalingState: state });
	},

	// 更新 ICE 连接状态
	setIceConnectionState: (state) => {
		console.log("设置 ICE 连接状态:", state);
		set({ iceConnectionState: state });
	},

	// 更新连接状态
	setConnectionState: (state) => {
		console.log("设置连接状态:", state);
		set({ connectionState: state });
	},

	// 更新媒体流
	setStream: (stream) => {
		console.log("设置媒体流:", {
			hasStream: !!stream,
			streamDetails: stream
				? {
						active: stream.active,
						id: stream.id,
						tracks: stream.getTracks().map((t) => ({
							kind: t.kind,
							enabled: t.enabled,
							readyState: t.readyState,
						})),
					}
				: null,
		});
		set({ stream });
	},

	// 设置错误
	setError: (error) => {
		console.log("设置错误:", error);
		set({ error });
	},

	// 设置 ICE restart 状态
	setIceRestarting: (isRestarting) => {
		console.log("设置 ICE restart 状态:", isRestarting);
		set({ isIceRestarting: isRestarting });
	},

	// 重置所有状态
	reset: () => {
		console.log("重置所有状态");
		set(initialState);
	},
}));
